import { useEducationalProgramControllerGetEduOrgGrantsQuery } from '@api/admin/adminGeneratedApi';

export const useGetPrograms = () => {
  const { data, isLoading } = useEducationalProgramControllerGetEduOrgGrantsQuery();

  return { data, isLoading };
};
